const React = require("react");
const withReDelay = require("mn-utils/withReDelay");
const {apiAdminWithdrawList} = require("../../../../../../api/admin/withdraws");
const virtualOutputComponentProvider = require("../../../../../../utils/virtualOutputComponentProvider");
const {getDefaultFilterParams, initFilter, IntervalFilterAdmin} = require("../../../../../dumb/IntervalFilterCustom");

const TableHeader = require("./components/TableHeader");
const TableItem = require("./components/TableItem");

const filter$ = initFilter();

module.exports = virtualOutputComponentProvider({
  state: {
    filter: filter$,
  },
  rowHeight: 60,
  request: apiAdminWithdrawList,
  getParams: getDefaultFilterParams,
  wrapper(render, setState, self) {
    return (state, props) => {
      const update = withReDelay(self.update, 1000);
      function handleChangeFilter(filter) {
        filter$.emit({
          ...state.filter,
          ...filter,
        });
        update();
      }

      const filter = state.filter;

      return (
        <>
          <IntervalFilterAdmin
            className="mt10 m0@m"
            data={filter}
            onChange={handleChangeFilter}
            // report={{
            //   prefix: 'global-withdrawals',
            //   url: '/f2c/v1/admin/dashboard/monthly-statements/'
            // }}
            update={self.update}
            search={{
              className: 'wmin180 fx1',
              placeholder: 'Search',
            }}
          />
          <div className="rlv h100vh-600 h100vh-280.fullSize">
            <div className="ovxA abs s">
              <div className="wmin1725 rlv h">
                <TableHeader self={self} />
                <div className="abs sh st45 sb c0>.CircularProgress">
                  {render(TableItem)}
                </div>
              </div>
            </div>
          </div>
        </>
      );
    };
  }
});
